import { gql } from '@apollo/client'

export const CREATE_USER_REVIEW_MUTATION = gql`
  mutation createUserReview(
    $order: Int!
    $rating: Int!
    $review: String!
    $product: String!
    $reasons: [String]
  ) {
    createUserReview(
      order: $order
      rating: $rating
      review: $review
      product: $product
      reasons: $reasons
    ) {
      __typename
      ... on GenericError {
        error
      }
      ... on GenericResponse {
        result
      }
    }
  }
`
